{
  "EMOJI": {
    "PLACEHOLDER": "Search emojis",
    "NOT_FOUND": "No emoji match your search",
    "REMOVE": "നീക്കം ചെയ്യുക"
  }
}
